import { Modal, TrackedButton, Typography } from '@automata/ui';
import { ParameterDefinition } from '@automata/wfb-api/src/apis/wfbApiSchemas';
import { Box, Stack } from '@mui/system';

import { getParameterValueStr } from '../../../utils/parameters';

interface DeleteParameterReferenceModalProps {
  parameter: ParameterDefinition;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteParameterReferenceModal = ({
  parameter,
  onClose,
  onDelete,
}: DeleteParameterReferenceModalProps) => {
  const defaultValue = getParameterValueStr(parameter);

  return (
    <Modal open title={`Delete ${parameter.name}`} onClose={onClose}>
      <Box>
        <Stack spacing={2} marginBottom={2}>
          <Typography variant="body1">
            This parameter reference is actively used in your workflow. If you
            delete it, the default value <strong>{defaultValue}</strong> will be
            applied to all parameters that use it.
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <TrackedButton
            trackLabel="workflowBuilder.newParameterReferenceModal.Cancel"
            color="primary"
            variant="text"
            onClick={onClose}
          >
            Cancel
          </TrackedButton>
          <TrackedButton
            trackLabel="workflowBuilder.newParameterReferenceModal.Create"
            color="primary"
            variant="contained"
            onClick={onDelete}
          >
            Delete
          </TrackedButton>
        </Stack>
      </Box>
    </Modal>
  );
};
